 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "-legacy." + {"chunk-06e1afd4":"bf4fb693","chunk-09ed1918":"00904446","chunk-14e8beed":"7b575ad8","chunk-16fc3399":"55c04232","chunk-1c7eb328":"b5fa52b0","chunk-20b874a9":"65d3dd37","chunk-2b8e8e3a":"f7952a20","chunk-2d0ab173":"fe49bee1","chunk-2d0b2186":"02a0c7a8","chunk-2d0b32d8":"6323c35a","chunk-2d0c22e6":"3ca3679e","chunk-2d0c94cb":"6d55af77","chunk-2d0cf113":"c49dc983","chunk-2d0e906b":"876ce41b","chunk-2d2086aa":"f7e916d5","chunk-2d216626":"f5efa5b6","chunk-36a56e7a":"63285db5","chunk-4a764ccc":"a950c795","chunk-5218c545":"169738fa","chunk-b063d67a":"94f3d34f","chunk-582b98f7":"7b1d90a5","chunk-73b72180":"7cff1ad5","chunk-1ea952b8":"2835a10e","chunk-6f0c1278":"9f4fd574","chunk-047c53ed":"bdfcff64","chunk-abce1db2":"b06df695","chunk-2d21d7eb":"f63e8ffe","chunk-2d21d8bc":"658071e2","chunk-2d231224":"1d64563f","chunk-3387a990":"566848b5","chunk-3d4c64e9":"51ad8fcc","chunk-45f720b4":"ea5695c6","chunk-067b54b4":"44f22391","chunk-2d0e1d96":"2e580adf","chunk-aa4a7b42":"507ea675","chunk-4ab92aa2":"dfa6810a","chunk-4dd1088a":"1e25db60","chunk-5964e8c4":"b9ab207c","chunk-62137f86":"8c2ef72c","chunk-6d728209":"ad5361ce","chunk-2d20ec90":"46de48a7","chunk-75989b76":"f08d77a9","chunk-78cda9ac":"100b0c1c","chunk-7c78ab76":"a2792751","chunk-be479a08":"b567e6a4","chunk-d9d4e8d2":"85fed483","chunk-f047ead8":"cb1724be","chunk-2d21b87b":"cab6ea58"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-14e8beed":1,"chunk-16fc3399":1,"chunk-1c7eb328":1,"chunk-20b874a9":1,"chunk-2b8e8e3a":1,"chunk-4a764ccc":1,"chunk-5218c545":1,"chunk-b063d67a":1,"chunk-582b98f7":1,"chunk-73b72180":1,"chunk-1ea952b8":1,"chunk-6f0c1278":1,"chunk-047c53ed":1,"chunk-abce1db2":1,"chunk-3387a990":1,"chunk-3d4c64e9":1,"chunk-45f720b4":1,"chunk-4ab92aa2":1,"chunk-4dd1088a":1,"chunk-5964e8c4":1,"chunk-62137f86":1,"chunk-6d728209":1,"chunk-78cda9ac":1,"chunk-d9d4e8d2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-06e1afd4":"31d6cfe0","chunk-09ed1918":"31d6cfe0","chunk-14e8beed":"e322ecba","chunk-16fc3399":"4a80fa86","chunk-1c7eb328":"cb85ac59","chunk-20b874a9":"e322ecba","chunk-2b8e8e3a":"e322ecba","chunk-2d0ab173":"31d6cfe0","chunk-2d0b2186":"31d6cfe0","chunk-2d0b32d8":"31d6cfe0","chunk-2d0c22e6":"31d6cfe0","chunk-2d0c94cb":"31d6cfe0","chunk-2d0cf113":"31d6cfe0","chunk-2d0e906b":"31d6cfe0","chunk-2d2086aa":"31d6cfe0","chunk-2d216626":"31d6cfe0","chunk-36a56e7a":"31d6cfe0","chunk-4a764ccc":"9ee9c42e","chunk-5218c545":"247f079a","chunk-b063d67a":"3fa5c7f0","chunk-582b98f7":"ca3efb95","chunk-73b72180":"52479a70","chunk-1ea952b8":"444d76bc","chunk-6f0c1278":"7d2a767c","chunk-047c53ed":"2b5e8c76","chunk-abce1db2":"1c3d05bf","chunk-2d21d7eb":"31d6cfe0","chunk-2d21d8bc":"31d6cfe0","chunk-2d231224":"31d6cfe0","chunk-3387a990":"e322ecba","chunk-3d4c64e9":"76678a77","chunk-45f720b4":"e322ecba","chunk-067b54b4":"31d6cfe0","chunk-2d0e1d96":"31d6cfe0","chunk-aa4a7b42":"31d6cfe0","chunk-4ab92aa2":"21aa007e","chunk-4dd1088a":"e322ecba","chunk-5964e8c4":"e322ecba","chunk-62137f86":"e322ecba","chunk-6d728209":"e322ecba","chunk-2d20ec90":"31d6cfe0","chunk-75989b76":"31d6cfe0","chunk-78cda9ac":"56bc8f79","chunk-7c78ab76":"31d6cfe0","chunk-be479a08":"31d6cfe0","chunk-d9d4e8d2":"e322ecba","chunk-f047ead8":"31d6cfe0","chunk-2d21b87b":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://client-app.solidprofessor.com/blue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
